export const SHOW_GLOBAL_ERROR = 'SHOW_GLOBAL_ERROR'
export const SET_GLOBAL_ISB3USER = 'SET_GLOBAL_ISB3USER'
export const SET_COMPANY_BASIC_INFO = 'SET_COMPANY_BASIC_INFO'
export const SET_DEFAULT_SHIPPING_ADDRESS = 'SET_DEFAULT_SHIPPING_ADDRESS'
export const SET_DEFAULT_BILLING_ADDRESS = 'SET_DEFAULT_BILLING_ADDRESS'
export const SET_ADDRESSES = 'SET_ADDRESSES'
export const SET_COUNTRIES = 'SET_COUNTRIES'
export const SET_BASIC_ADDRESS_INFO = 'SET_BASIC_ADDRESS_INFO'
export const SET_GLOBAL_ISPENDING = 'SET_GLOBAL_ISPENDING'
export const SET_PAYMENT_METHODS = 'SET_PAYMENT_METHODS'
export const SET_CHECKOUT_SETTINGS = 'SET_CHECKOUT_SETTINGS'
export const SET_CHECKOUT_SHIPPING_ISCOMPLETE = 'SET_CHECKOUT_SHIPPING_ISCOMPLETE'
